import AutoSizedTextArea from 'components/inputs/AutoSizedTextArea';
import LabelWrap from 'components/inputs/LabelWrap';
import Modal, { modalContentClass } from 'components/Modal';
import { FC, useState } from 'react';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .${modalContentClass} {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 350px;
    max-width: 480px;

    textarea {
      width: auto;
    }
  }
`;

interface RunnerOverrideReasonModalProps {
  runnerName: string;
  onConfirm(reason: string): void;
  onClose(): void;
}

/**
 * Nödfallsundantaget för runnerspärren: en runner får inte köra ett uppdrag med kundkontakt
 * (hämtning hos kund eller hemleverans). Med en motivering går tilldelningen ändå igenom, och
 * servern skriver motiveringen som intern kommentar på ärendet.
 */
const RunnerOverrideReasonModal: FC<RunnerOverrideReasonModalProps> = ({
  runnerName,
  onConfirm,
  onClose,
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError('Ange varför en runner måste ta uppdraget');
      return;
    }
    onConfirm(reason.trim());
  };

  return (
    <StyledModal
      buttons={[
        {
          label: 'Tilldela ändå',
          onClick: handleConfirm,
        },
        {
          label: 'Avbryt',
          onClick: onClose,
        },
      ]}
      onClose={onClose}
      title="Runner på uppdrag med kundkontakt"
    >
      <p>
        {runnerName} är runner och ska inte ha kundkontakt. Tilldela bara i nödfall,
        när ingen annan fälttestare kan ta uppdraget. Motiveringen sparas som intern
        kommentar på ärendet.
      </p>
      <LabelWrap label="Motivering" errorLabel={error || undefined}>
        <AutoSizedTextArea
          value={reason}
          onChange={(e) => {
            setReason((e.target as HTMLTextAreaElement).value);
            setError('');
          }}
          placeholder="T.ex. ingen annan tillgänglig, kunden informerad"
        />
      </LabelWrap>
    </StyledModal>
  );
};

export default RunnerOverrideReasonModal;
